import {
  Form,
  Spin,
  Table,
  Row,
  Input,
  Icon,
  Button,
  Dropdown,
  Menu,
  Popconfirm,
  Empty,
} from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./tickets.css";
import Highlighter from "react-highlight-words";
import { showSuccessToast } from "../general/ToastHelper";
import history from "../../utils/history";
import { TicketService } from "../../services/Ticket/TicketService";
import { Translation } from "react-i18next";
import i18next from "i18next";
class Tickets extends Component {
  constructor(props) {
    super(props);

    this.props.context.setCurrentComponent("tickets");
    this.state = {
      isFetching: false,
      data: [],
      visible: false,
      loading: false,
      searchText: "",
      edit: false,
      ticketData: null,
      recordData: null,
      customerId: this.props.customerId ? this.props.customerId : "",
      isCustomerTickets: this.props.isCustomerTickets
        ? this.props.isCustomerTickets
        : false,
      searchedColumn: "",
    };
    this.ticketService = new TicketService();
  }

  componentDidMount() {
    if (this.state.customerId && this.state.isCustomerTickets) {
      this.getCustomerTickets();
    } else {
      this.getAllTickets();
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }

  async getAllTickets() {
    try {
      this.setState({ isFetching: true });

      let data = await this.ticketService.getAllTicketsService(
        this.props.context.session_id,
        this.props.context.user.accountId
      );
      this.setState({ data: this.formatData(data), isFetching: false });
    } catch (e) {
      this.setState({ isFetching: false });

      handleError(e);
    }
  }
  async getCustomerTickets() {
    try {
      this.setState({ isFetching: true });

      let data = await this.ticketService.getTicketByCustomerId(
        this.props.context.session_id,
        this.state.customerId
      );

      this.setState({
        data: this.formatData(data),
        isFetching: false,
      });
    } catch (e) {
      this.setState({ isFetching: false });

      handleError(e);
    }
  }

  handleRefresh() {
    if (this.state.customerId && this.state.isCustomerTickets) {
      this.getCustomerTickets();
    } else {
      this.getAllTickets();
    }
  }

  async deleteRecord(record) {
    try {
      let data = await this.ticketService.deleteTicket(
        this.props.context.session_id,
        record.ticketId
      );
      if (data.statusCode === 0)
        showSuccessToast(i18next.t(" Ticket deleted successfully"));
      this.handleRefresh();
    } catch (e) {
      handleError(e);
    }
  }

  addNewTicket = () => {
    history.push("/home/ticket/create");
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };
  viewticket(id) {
    this.setState({ isCustomerTickets: false });
    history.push(`/home/ticket/view/${id}`);
  }
  renderActionDropdown(record) {
    const menu = (
      <Menu>
        <Menu.Item onClick={() => this.viewticket(record.ticketId)}>
          <span>{i18next.t("View Details")}</span>
          <Icon className={"view-details-style"} type="eye" />
        </Menu.Item>
        {this.props.context.user.userType === "ADMIN" ? (
          <Menu.Item>
            <Popconfirm
              title={i18next.t("Are you sure delete this Ticket? ")}
              onConfirm={() => this.deleteRecord(record)}
              okText={i18next.t("Yes")}
              cancelText={i18next.t("No")}
            >
              <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
                {i18next.t("Delete Ticket")}
                <Icon className={"delete-account-style"} type="delete" />
              </a>
            </Popconfirm>
          </Menu.Item>
        ) : null}
      </Menu>
    );
    return (
      <Dropdown overlay={menu}>
        <Button size="small" style={{ borderWidth: 0 }}>
          <Icon item={record} type="more" />
        </Button>
      </Dropdown>
    );
  }
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={i18next.t(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => {
            this.setState({ searchedColumn: dataIndex });
            this.handleSearch(selectedKeys, confirm);
          }}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => {
            this.setState({ searchedColumn: dataIndex });
            this.handleSearch(selectedKeys, confirm);
          }}
          icon="search"
          size="small"
          style={
            this.props.context.curr_dir === "ltr" &&
            this.props.context.curr_lang === "en"
              ? { width: 100, marginRight: 8 }
              : { width: 100, marginLeft: 8 }
          }
        >
          {i18next.t("Search")}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 80 }}
        >
          {i18next.t("Reset")}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: "#d73a31" }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] != null &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };
  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  itemRender = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "right" : "left"}
          />
        </a>
      );
    }
    if (type === "next") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "left" : "right"}
          />
        </a>
      );
    }
    return originalElement;
  };

  formatData(data) {
    const updated_data = [];

    for (var i = 0; i < data.ivrList.length; i++) {
      var row = {};
      row["key"] = i + 1;
      row["customer"] = data.ivrList[i]["customerId"];
      row["category"] = data.ivrList[i]["categoryCode"];
      row["priority"] = i18next.t(data.ivrList[i]["priority"]);
      row["subject"] = data.ivrList[i]["subject"];
      row["assignedTo"] = data.ivrList[i]["assignedTo"];
      row["status"] = i18next.t(data.ivrList[i]["status"]);
      row["closed by"] = data.ivrList[i]["closedBy"];
      row["ticketNumber"] = data.ivrList[i]["number"].toString();
      row["ticketId"] = data.ivrList[i]["id"].toString();
      updated_data.push(row);
    }
    return updated_data;
  }

  render() {
    let { isFetching } = this.state;
    const columns = [
      {
        title: i18next.t("ticket number"),
        dataIndex: "ticketNumber",
        key: "ticketNumber",
        ...this.getColumnSearchProps("ticketNumber"),
        render: (text) =>
          this.state.searchedColumn === "ticketNumber" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("cutsomer"),
        dataIndex: "customer",
        key: "customer",
        ...this.getColumnSearchProps("customer"),
        render: (text) =>
          this.state.searchedColumn === "customer" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("ticket category"),
        dataIndex: "category",
        key: "category",
        ...this.getColumnSearchProps("category"),
        render: (text) =>
          this.state.searchedColumn === "category" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("priority"),
        dataIndex: "priority",
        key: "priority",
        ...this.getColumnSearchProps("priority"),
        render: (text) =>
          this.state.searchedColumn === "priority" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("subject"),
        dataIndex: "subject",
        key: "subject",
        ...this.getColumnSearchProps("subject"),
        render: (text) =>
          this.state.searchedColumn === "subject" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("status"),
        dataIndex: "status",
        key: "status",
        ...this.getColumnSearchProps("status"),
        render: (text) =>
          this.state.searchedColumn === "status" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("assigned to"),
        dataIndex: "assignedTo",
        key: "assignedTo",
        ...this.getColumnSearchProps("assignedTo"),
        render: (text) =>
          this.state.searchedColumn === "assignedTo" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },

      {
        title: i18next.t("Action"),
        dataIndex: "operation",
        render: (text, record) =>
          this.state.data.length >= 1
            ? this.renderActionDropdown(record)
            : null,
      },
    ];

    return (
      <Translation>
        {(t) => (
          <Page
            title={t("Manage Tickets")}
            hasBackArrow={this.state.isCustomerTickets ? true : false}
            customerTickets={this.state.isCustomerTickets ? true : false}
            back={() => {
              this.props.back();
            }}
          >
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                {this.state.isCustomerTickets ? null : (
                  <div>
                    <Button
                      className="button-add-account"
                      onClick={this.addNewTicket}
                      icon="plus"
                    />
                    <span>{t("Add New Ticket")} </span>
                  </div>
                )}
                <Row style={{ marginTop: "25px" }}></Row>
                <Table
                  columns={columns}
                  bodyStyle={{
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "8px",
                    marginBottom: "25px",
                  }}
                  dataSource={this.state.data}
                  pagination={{
                    position: "bottom",
                    pageSize: 10,
                    itemRender: this.itemRender,
                  }}
                  bordered
                  locale={{
                    emptyText: (
                      <Empty
                        description={i18next.t("Empty")}
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                      />
                    ),
                  }}
                />
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(withSharedStateConsumer(withRouter(Tickets)));
